/**
 * Lightweight internal dev-alert helper.
 *
 * Fire-and-forget email notification for when the app detects it silently
 * dropped/excluded data it probably shouldn't have (e.g. a failed Reference
 * Price match, a holder missing required data) -- not user-facing, purely so
 * a real data gap surfaces as an email instead of vanishing with no signal.
 * This is a stopgap, not a fix: it doesn't change the underlying drop
 * behavior, it just makes sure someone finds out about it.
 *
 * Uses the same /portal/auth/send-email endpoint as every other transactional
 * email in this app (see send-messages.js, ledgers.js, investor-agreement.js,
 * etc.), reading client/userid/cookie from the ambient globals set at page
 * load -- matching the convention used at every other call site for this
 * endpoint. Failures are swallowed (console.error only): an alert that fails
 * to send should never break the calling feature.
 */

const DEV_ALERT_RECIPIENT = 'cmcconnell@nthround.com';

/**
 * @param {string} subject - short description of what was dropped
 * @param {string} message - HTML body; details of what was excluded and why
 */
export function sendDevAlert(subject, message) {
	try {
		axios
			.post(
				'https://api.nthround.io/portal/auth/send-email',
				JSON.stringify({
					client: typeof client !== 'undefined' ? client : '',
					userid: typeof authedUser !== 'undefined' ? authedUser : '',
					cookie: typeof cookie !== 'undefined' ? cookie : '',
					sender_name: 'Nth Round System Alert',
					recipient: DEV_ALERT_RECIPIENT,
					subject: `[Dev Alert] ${subject}`,
					message,
				})
			)
			.catch((err) => console.error('sendDevAlert failed to send:', err));
	} catch (err) {
		console.error('sendDevAlert failed:', err);
	}
}
